"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";

class SystemProperty extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "SystemProperty";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/system-properties"
    );
  }

  static getPrivateApiPath() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/private/system-properties"
    );
  }

  getApiPathForCreate() {
    console.error("not implemented.");
  }

  getApiPathForRefreshUpdateAndDelete() {
    console.error("not implemented.");
  }

  getAdminPath() {
    console.error("Cannot go to a system property.");
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultTitle() {
    return this.propertyName;
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }
}

export default SystemProperty;
